import React from 'react';

import { DutyHourTypeDynFlag } from 'generated';
import { useTranslation } from 'react-i18next';

import { ControlledFlagCheckbox } from 'components/shared/ControlledFields/ControlledFlagCheckbox';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

export const AbsenceSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <MultiStepForm.Section title={t('dutyHourTypes.section.absence')}>
      <ControlledFlagCheckbox<DutyHourTypeDynFlag>
        name="flags"
        flag="BLOCK_INSIDE_ABSENCE"
        label={t('dutyHourTypes.fieldName.dontUseWhenAbsent')}
      />
    </MultiStepForm.Section>
  );
};
